<template>
  <div>
    <CRow>
      <CCol sm="12">
        <SchoolsTable
          :items="schools"
          hover
          striped
          border
          small
          fixed
          caption="Colegios"
          @refresh="refreshItems"
        />
      </CCol>
    </CRow>
  </div>
</template>

<script>
import SchoolsTable from '../../components/schools/SchoolsTable.vue'
import schools from '../../services/schools';
import store from '../../store'

export default {
  name: 'Schools',
  components: { SchoolsTable },
  data: function () {
		return {
            schools: []
        }
  },
  mounted: async function() {
    this.loading();
    let response = await schools.get();

    if(response.type == "success"){
      this.schools = response.data;
    }

    this.loaded();
  },
  methods: {
    async refreshItems (items){
      this.loading();
      this.schools = await items;
      this.loaded();
    },
    loading(){
      store.commit('loading');
    },
    loaded(){
      store.commit('loaded');
    }
  }
}
</script>
